import { render } from "./BlViewHistory.vue?vue&type=template&id=2627d964&scoped=true"
import script from "./BlViewHistory.vue?vue&type=script&lang=js"
export * from "./BlViewHistory.vue?vue&type=script&lang=js"

import "./BlViewHistory.vue?vue&type=style&index=0&id=2627d964&scoped=true&lang=scss"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2627d964"]])

export default __exports__